import { render, staticRenderFns } from "./DirectStore.vue?vue&type=template&id=490de30b&"
import script from "./DirectStore.vue?vue&type=script&lang=js&"
export * from "./DirectStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports